import { useEffect } from 'react';
import { AgentScriptBox } from 'components/shared/agentScriptBox';
import { Button } from 'components/shared/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';

import './conversionFailure.scss';
import { ExternalLink } from 'components/shared/externalLink';
import { EXTERNAL_PATH } from 'interfaces/pathTypes';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { AUTH_TYPE } from 'interfaces/authTypes';
import { getCustomerInsuranceSummaryAction } from 'actions/getCustomerInsuranceSummaryAction';
import { analyticsUserType, sendAnalytics, GTM_EVENT_TYPES } from 'analytics';
import { FullPolicyData } from 'interfaces/customerDataTypes';

interface ConversionFailureProps {
  selectedPolicy: FullPolicyData;
}

export const ConversionFailure = ({ selectedPolicy }: ConversionFailureProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const authentication = useAppSelector((state) => state.authentication);
  const { authType, isAgent } = authentication;
  const { policyNumber, customerRenewalOptOut } = selectedPolicy;

  useEffect(() => {
    sendAnalytics({
      event: GTM_EVENT_TYPES.RENEWAL_FAILURE,
      detail: {
        usertype: analyticsUserType(isAgent),
        is_auto_renewal: !customerRenewalOptOut,
        policy_ref: policyNumber
      }
    });
    return () => {
      dispatch(getCustomerInsuranceSummaryAction({ urlAuthType: authType }));
    };
  }, [dispatch, authType]);

  return (
    <div className="conversion-failure-container">
      {authType === AUTH_TYPE.AGENT && (
        <AgentScriptBox scriptTitle="Error converting renewal" agentScript="Please refer to Customer Accounts team." />
      )}
      <FontAwesomeIcon icon={faTriangleExclamation} size="6x" color="red" />
      <h2>SORRY, WE&apos;VE EXPERIENCED A PROBLEM</h2>
      <p className="conversion-failure-text">Get in touch to process your renewal</p>
      <ExternalLink href={EXTERNAL_PATH.CONTACT_US} id="contact-us">
        <Button text="Contact us" variant="secondary" />
      </ExternalLink>
    </div>
  );
};
